import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthguardService } from './services/authguard/authguard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'tabs',
    canActivate: [AuthguardService],
    loadChildren: () => import('./component/tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'login',
    canActivate: [AuthguardService],
    loadChildren: () => import('./component/common/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'password',
    canActivate: [AuthguardService],
    loadChildren: () => import('./component/common/password/password.module').then(m => m.PasswordPageModule)
  },
  {
    path: 'terms-and-conditions',
    canActivate: [AuthguardService],
    loadChildren: () => import('./component/welcome-pages/terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsPageModule)
  },
  {
    path: 'upload-profile-image',
    canActivate: [AuthguardService],
    loadChildren: () => import('./component/welcome-pages/upload-profile-image/upload-profile-image.module').then(m => m.UploadProfileImagePageModule),
  },
  {
    path: 'date-of-birth/:type',
    canActivate: [AuthguardService],
    loadChildren: () => import('./component/welcome-pages/date-of-birth/date-of-birth.module').then(m => m.DateOfBirthPageModule),
  },
  {
    path: 'date-of-anniversary',
    canActivate: [AuthguardService],
    loadChildren: () => import('./component/welcome-pages/date-of-anniversary/date-of-anniversary.module').then(m => m.DateOfAnniversaryPageModule)
  },
  {
    path: 'interests',
    canActivate: [AuthguardService],
    loadChildren: () => import('./component/welcome-pages/interests/interests.module').then(m => m.InterestsPageModule)
  },
  {
    path: 'testimonial',
    loadChildren: () => import('./component/testimonial/testimonial.module').then(m => m.TestimonialPageModule)
  },
  {
    path: 'request-for-download',
    loadChildren: () => import('./component/request-for-download/request-for-download.module').then( m => m.RequestForDownloadPageModule)
  },




 





















  // {
  //   path: 'tearm-page',
  //   loadChildren: () => import('./carlsberg/user/terms/terms.module').then( m => m.TermsPageModule)
  // },
  // {
  //   path: 'welcome-video',
  //   loadChildren: () => import('./carlsberg/login/welcome-video/welcome-video.module').then( m => m.WelcomeVideoPageModule)
  // },
  // {
  //   path: "language",
  //   loadChildren: () => import('./carlsberg/user/language/language.module').then( m => m.LanguagePageModule)
  // },
  // {


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
